import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from "../../../vendor/router-ROUTER_TARGET";

import IconHome from './svg/IconHome';
import { updateStoreHistory, resetTabBar } from "../../../actions/index";

function ButtonHome({ className, style }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onClick = () => {
    navigate('/home');
    dispatch(updateStoreHistory('/home'));
    dispatch(resetTabBar());
  }
  return (
    <div onClick={onClick} className={`button-home ${className}`} style={{...style, marginTop: -1, cursor: 'pointer'}}>
      <IconHome />
    </div>
  )
}

ButtonHome.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
}

export default ButtonHome;
